/** Маппинг ролей из RBAC на человекочитаемые названия */
const ROLE_LABELS: Record<string, string> = {
  'role.admin': 'Администратор',
  'role.user': 'Пользователь',
};

export function getRoleLabel(role: string): string {
  return ROLE_LABELS[role.toLowerCase()] ?? role;
}

/** Получение инициалов пользователя из email */
export function getUserInitials(email?: string): string {
  if (!email) return 'ПУ';
  const beforeAt = email.split('@')[0];
  if (beforeAt.length >= 2) {
    return beforeAt.substring(0, 2).toUpperCase();
  }
  return beforeAt.toUpperCase();
}
